import timeingStuff from "@serie3/freelancesplaceapi/Domain/Shared/timeingStuff";
import { useEffect, useState } from "react";
import TimetrackingDomain from "@serie3/freelancesplaceapi/Domain/Timetracking/TimetrackingDomain";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import listHandler from "@serie3/common/Domain/listHandler";

const cellStyle = {
  padding: "12px 12px",
  fontSize: "0.9rem",
  color: "#212121",
  borderBottom: "1px solid #f5f5f5",
  verticalAlign: "middle",
};

const TaskRow = ({
  task,
  deleteTaskFunction,
  editTaskFunction,
  startSelection = false,
  selected = [],
  setSelected,
}) => {
  const fullWorkDay = 8 * 60 * 60;
  const workingHours = fullWorkDay - task.total_time;
  const [totalTime, setTotalTime] = useState(0);
  const [missedTime, setMissedTime] = useState(0);
  const [isSelected, setIsSelected] = useState(false);
  const [hovered, setHovered] = useState(false);
  const isWeekend = TimetrackingDomain.isWeekend(task.date);

  useEffect(() => {
    if (typeof task.ende !== "undefined") {
      setTotalTime(timeingStuff.secondsToTimeString(task.total_time));
      setMissedTime(timeingStuff.secondsToTimeString(workingHours, true));
    } else {
      setTotalTime(0);
      setMissedTime(0);
    }
  }, [task]);

  useEffect(() => {
    if (selected.length === 0) setIsSelected(false);
  }, [selected]);

  const addToSelection = () => {
    selected.push(task);
    setSelected([...selected]);
    setIsSelected(true);
  };

  const removeFromSelection = () => {
    const tmpSelected = listHandler.deleteWithoutCall(task, selected);
    setSelected([...tmpSelected]);
    setIsSelected(false);
  };

  const rowBg = isSelected
    ? "#e8f0fe"
    : hovered
    ? "#f5f9ff"
    : isWeekend
    ? "#fff8f8"
    : "#fff";

  const dateBadgeBg = isWeekend ? "#ffebee" : "#e8f5e9";
  const dateBadgeColor = isWeekend ? "#c62828" : "#2e7d32";

  return (
    <tr
      style={{ background: rowBg, cursor: "pointer", transition: "background 0.15s" }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {startSelection && (
        <td style={cellStyle}>
          <button
            onClick={!isSelected ? addToSelection : removeFromSelection}
            style={{
              width: "26px",
              height: "26px",
              borderRadius: "6px",
              border: "none",
              background: isSelected ? "#1a73e8" : "#f0f0f0",
              color: isSelected ? "#fff" : "#616161",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "0.75rem",
            }}
          >
            <FontAwesomeIcon icon={!isSelected ? faPlus : faCheck} />
          </button>
        </td>
      )}
      <td style={cellStyle} onClick={() => editTaskFunction(task)}>
        <span style={{
          background: dateBadgeBg,
          color: dateBadgeColor,
          fontWeight: 600,
          fontSize: "0.82rem",
          padding: "3px 10px",
          borderRadius: "20px",
        }}>
          {task.date}
        </span>
      </td>
      <td style={{ ...cellStyle, textAlign: "center", color: "#616161" }} onClick={() => editTaskFunction(task)}>
        {task.start}
      </td>
      <td style={{ ...cellStyle, textAlign: "center", color: "#616161" }} onClick={() => editTaskFunction(task)}>
        {task.ende || "—"}
      </td>
      <td style={{ ...cellStyle, textAlign: "center", color: "#9e9e9e" }} onClick={() => editTaskFunction(task)}>
        {timeingStuff.convertToHHmm(task.pause_time)}
      </td>
      <td style={{ ...cellStyle, textAlign: "center", fontWeight: 700 }} onClick={() => editTaskFunction(task)}>
        {totalTime}
      </td>
      <td style={{
        ...cellStyle,
        textAlign: "center",
        fontWeight: 700,
        color: workingHours > 0 ? "#c62828" : "#2e7d32",
      }} onClick={() => editTaskFunction(task)}>
        {missedTime}
      </td>
      <td style={{
        ...cellStyle,
        maxWidth: "200px",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        fontWeight: 500,
      }} onClick={() => editTaskFunction(task)}>
        {task.title}
      </td>
      <td style={{ ...cellStyle, textAlign: "center" }}>
        <button
          onClick={() => deleteTaskFunction(task)}
          style={{
            background: "#ffebee",
            color: "#c62828",
            border: "none",
            borderRadius: "6px",
            width: "28px",
            height: "28px",
            cursor: "pointer",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "0.75rem",
          }}
        >
          <FontAwesomeIcon icon={faTrash} />
        </button>
      </td>
    </tr>
  );
};

export default TaskRow;
